import { FC } from 'react';

import Lottie from 'react-lottie';

const LOTTIE_OPTIONS = {
  loop: false,
  autoplay: true,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

interface IAnimation {
  data: object;
  width: number;
  height: number;
}

interface IAnimationProps {
  animation: IAnimation;
  loop?: boolean;
}

const Animation: FC<IAnimationProps> = ({ animation, loop = false }) => {
  const { data, width, height } = animation;

  return (
    <Lottie
      isPaused={false}
      isStopped={false}
      isClickToPauseDisabled={true}
      style={{ transition: '.3s' }}
      width={width}
      height={height}
      options={{
        ...LOTTIE_OPTIONS,
        loop,
        animationData: data,
      }}
    />
  );
};

export default Animation;
